import { getSafeInnerHTMLProp } from '@/helpers/getSafeInnerHTML';
import clsx from 'clsx';
import styles from './BenefitsCategory.module.scss';
import type { BenefitsCategoryProps } from './types';

const BenefitsCategory = ({
  color = 'surrogate',
  children,
  icon,
  id,
  title,
}: BenefitsCategoryProps) => {
  return (
    <div className={clsx(styles.base, styles[color])} id={`category-${id}`}>
      <div className={styles.contentWrapper}>
        <h2 className={clsx(styles.title, styles.colorFilter)}>
          <img src={icon.path} alt="Kategorie-Icon" />
          <span {...getSafeInnerHTMLProp(title)} />
        </h2>
        <div className={styles.grid}>{children}</div>
      </div>
    </div>
  );
};

export default BenefitsCategory;
